import React from 'react';
import { Navbar } from '../components/SalesLetter/Navbar';
import { Hero } from '../components/SalesLetter/Hero';
import { LetterOpening } from '../components/SalesLetter/LetterOpening';
import { HowItWorks } from '../components/SalesLetter/HowItWorks';
import { WhyTailoring } from '../components/SalesLetter/WhyTailoring';
import { Features } from '../components/SalesLetter/Features';
import { Audience } from '../components/SalesLetter/Audience';
import { Privacy } from '../components/SalesLetter/Privacy';
import { Pricing } from '../components/SalesLetter/Pricing';
import { FAQ } from '../components/SalesLetter/FAQ';
import { Footer } from '../components/SalesLetter/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-167">
      <Navbar data-id="element-168" />
      <main data-id="element-169">
        <Hero data-id="element-170" />
        <LetterOpening data-id="element-171" />
        <HowItWorks data-id="element-172" />
        <WhyTailoring data-id="element-173" />
        <Features data-id="element-174" />
        <Audience data-id="element-175" />
        <Privacy data-id="element-176" />
        <Pricing data-id="element-177" />
        <FAQ data-id="element-178" />
      </main>
      <Footer data-id="element-179" />
    </div>;
}